// extracted by mini-css-extract-plugin
module.exports = {"row":"styles_row__glIDx","row__icon":"styles_row__icon__14rFf","row__description":"styles_row__description__1Rjkb","skeleton-animation":"styles_skeleton-animation__c2nhH"};